import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReportTableComponent } from './report-table.component';

import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CommonTranslationModule,
    CommonUIModule
  ],
  exports: [ReportTableComponent],
  declarations: [ReportTableComponent]
})
export class ReportTableModule { }
